import { apiClient, retryRequest } from './httpClient';

// Get notifications list with optional params (for sorting, pagination, etc.)
export async function getNotificationsList(endpoint, method = "GET", data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: method.toUpperCase(),
        ...options
    };

    if (data) {
        if (method.toUpperCase() === 'GET') {
            requestConfig.params = data;
        } else {
            requestConfig.data = data;
        }
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const apiError = new Error(error.data || 'API request failed');
        apiError.status = error.status || 500;
        apiError.endpoint = endpoint;
        apiError.method = method;
        throw apiError;
    }
}

// Delete notification
export async function deleteNotification(endpoint, body, options = {}) {
    const requestConfig = {
        url: `${endpoint}`,
        method: 'DELETE',
        data: body,
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'DELETE request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'DELETE';
        throw err;
    }
}


export async function changeStatusForMany(endpoint, payload, options = {}) {
    const requestConfig = {
        url: `${endpoint}`,   
        method: 'PUT',       
        data: payload,        
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'PUT request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'PUT';
        throw err;
    }
}


